import React from 'react';

function RoundRingIcon({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            {...props}
        >
            <path
                d="M14.0001 3.5C8.2103 3.5 3.5 8.21027 3.5 14C3.5 19.7897 8.2103 24.5 14.0001 24.5C19.7898 24.5 24.5 19.7897 24.5 14C24.5 8.21027 19.7898 3.5 14.0001 3.5ZM14.0001 22.7787C9.15943 22.7787 5.2213 18.8407 5.2213 14C5.2213 9.1594 9.15943 5.22131 14.0001 5.22131C18.8406 5.22131 22.7787 9.1594 22.7787 14C22.7787 18.8407 18.8406 22.7787 14.0001 22.7787Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default RoundRingIcon;
